// var d3 = {
//     ...require("d3-axis/dist/d3-axis.min"),
//     ...require("d3-scale/dist/d3-scale.min"),
//     ...require("d3-selection/dist/d3-selection.min"),
//     ...require("d3-geo/dist/d3-geo.min"),
//     ...require("d3-array/dist/d3-array.min"),
//     ...require("d3-scale-chromatic/dist/d3-scale-chromatic.min")
//   };
  
  
var d3 = require("d3/dist/d3.min");


  
  var { COLORS, classify, makeTranslate, formatStyle, wrapText, formatDate, getAPMonth } = require("./lib/helpers");
  var { isMobile } = require("./lib/breakpoints");
  
  
  module.exports = function(config) {


     // Clear existing graphic (for redraw)
     var containerElement = d3.select(config.container);
     containerElement.html("");    



    var colorScale = d3.scaleOrdinal()
    .domain(Object.keys(PEOPLE))
    .range([ "#A23520","#E38D2C",  "#17807E", "#51AADE" ])

    


    function renderLegend(){
      //Render the legend
      var legend = containerElement
        .append("ul")
        .attr("class", "key")
        .selectAll("g")
        .data(colorScale.domain())
        .enter()
          .append("li")
          .attr("class", (d, i) => `key-item key-${i} ${classify(d)}`);
      
      legend.append("b")
        .style("background-color", d => colorScale(d));
  
      legend.append("label").text(d => PEOPLE[d]);
        }
    
        

    
    

    


     
     function renderMap(){

          var aspectWidth = isMobile.matches ? 3.5 : 16;
          var aspectHeight = isMobile.matches ? 3 : 8;
          
   
         // Setup //
         var margin = {
            top: 60,
            right: 15,
            bottom: 40,
            left: 30,
          };

           // Annotation set up

           var annotationXOffset = -6;
           var annotationYOffset = -20;
           var annotationWidth = 70;
           var annotationLineHeight = 12;
         
           var ticksX = 5;
           var ticksY = 6;
           var unitsY = " million";
         
           if (isMobile.matches) {
             ticksX = 6;
             ticksY = 6;
             annotationWidth = 50;
             margin.left = 30;
             margin.top = 70;
            //  unitsY = "M";
           }
  

          
    
       

         // Calculate actual chart dimensions
         var width = config.width - margin.left - margin.right;
         var height = 400; 
        // var height = Math.ceil((config.width * aspectHeight) / aspectWidth) -
        // margin.top -
        // margin.bottom;

        // var data = config.data

        

        // Adds the svg canvas
        var svg = d3.select("#chart")
        .append("svg")
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
        .append('g')
        .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
        


        

        var data = config.data      
     

        var subgroups = ["Mike Lindell", "Douglas Frank", "David Clements", "Seth Keshel"]
          
        
        var x_axis_date_format = data.map(function(value, index){ return  formatDate.monthYear(new Date(value["year_month"]));});
        
          

        // List of groups = species here = value of the first column called group -> I show them on the X axis
        var groups = d3.map(data, function(d){return(d.year_month)}).keys()

 

          // Create d3 axis
          // Add X axis

         

          var xScale = d3
            .scaleTime()
            .range([0, width])
            .domain([new Date(2021, 0, 1, 0, 0, 0, 0), new Date(2022,6,0,0,0,0,0)]);

   
        

          // var xScale = d3.scalePoint()
          //     .domain(groups)
          //     .range([0, width])
          //     .padding(1);

          var xAxis = d3
            .axisBottom()
            .scale(xScale)
            .ticks(5)
            // .tickFormat((d,i) =>{ return x_axis_date_format[i];} );
            .tickFormat(function (d, i) {
              if (d.getMonth() % 2 && isMobile.matches) {
                return null;
              }
              if (d.getMonth() == 0) {
                return getAPMonth(d) + " " + formatDate.yearFull(d);
              } else {
                return getAPMonth(d);
              }
            });

          var yScale = d3.scaleLinear()
          .domain([0, 47])
          .range([ height, 0 ]);   

          var yAxis = d3
            .axisLeft()
            .scale(yScale)
            

          // Render axis to chart
          //Render x axis

          svg.append("g")
          .attr("class", "x axis")
          .attr("transform", "translate(0," + height + ")")
          .call(xAxis);

          svg.selectAll('.x.axis text')
          .attr('dy', 10)
          .call(wrapText, 35, 12);


          //Render y axis

          svg.append("g")
          .attr("class", "y axis")
          .call(yAxis);

          // Rend grid to chart

          //X Axis Grid

          var xAxisGrid = function() {
            return xAxis;
          };


          svg
            .append("g")
            .attr("class", "x grid")
            .attr("transform", makeTranslate(0, height))
            .call(
              xAxisGrid()
                .tickSize(-height, 0, 0)
                .tickFormat("")
              );


          // Y Axis grid
          var yAxisGrid = function() {
            return yAxis;
          };


          svg
            .append("g")
            .attr("class", "y grid")
            .call(
              yAxisGrid()
                .tickSize(-width, 0, 0)
                .tickFormat("")
            );



             
   
         
                  
             
     

        


               // Show the dots
          svg.append("g")
          .selectAll("g")
          // Enter in data = loop group per group
          .data(data)
          .enter().append("g")
            .attr("transform", function(d) {        
              
              return "translate(" + xScale(new Date(d.year_month)) + ",0)"; })
         
          .selectAll("circle")
          .data(function(d) {
      
           
            
           var final_result = [];
           var last_number = [];
           var flag = ["true"];
          
           subgroups.forEach(function(name){

           
           
              var start = flag[0]              
         
              
              if (start == "true" ){
                
                if(d[name] == 0){
                  return; // continue to next iteration
                } else {
                  
                  var number_array = d3.range(1,d[name]+1);
                  
                  var last_end = d[name];
                  last_number.push(last_end+1);

                  



                }              
                
              } else {

                  if (d[name]== 0){
                    return;
                  } else {

                    var new_start = last_number[0];
                   
                    
                    var new_end = new_start + d[name];
                    var number_array = d3.range(new_start, new_end  );
                    
                  
                    
                    last_number.length = 0;
                    
                    var last_end = new_end;
                    last_number.push(last_end)

                   



                  }             

              }

              //start the sub loop

              number_array.forEach(function(value){
                
                var temp = {key: name, number: value }; 

                
                               
                final_result.push(temp);


              })

              
              
              // flip the switch after the first name
              flag.length = 0;
              flag.push("false");
              

           })


                
           
         
           
            return final_result ; })
            .enter().append("circle")
              .attr("cx", function(d) { return xScale(d.key); })
              .attr("cy", function(d) {  return yScale(d.number); })
              .attr("r", "4")           
              .attr("fill", function(d) { return colorScale(d.key); }); 
              
              



        // Render annotations

        var order_dates = ANNOTATIONS;

        var dates = svg
          .append('g')
          .attr('class', 'date-annotations')
          .selectAll('line')
          .data(order_dates)
          .enter();
        // order line
        dates
          .append('line')
          .attr('x1', d => xScale(new Date(d['begin'])))
          .attr('x2', d => xScale(new Date(d['begin'])))
          .attr('y1',height)
          .attr('y2', 0)
          .attr('class', 'median-line');

        var annotation_text = dates
          .append('text')
          .classed('chart-label', true)
          .attr('x', function (d) {
            var add = d.anchor == 'left' ? -5 : 5;
            return xScale(new Date(d.begin)) + add;
          })
          .attr('y', 0)
          .attr('text-anchor',"middle")
          .html(d => d.text)
          .call(wrapText, isMobile.matches ? 60 : 100, annotationLineHeight);

          annotation_text.attr("transform", function(d){
            var h = d3.select(this).node().getBoundingClientRect().height;
            return(`translate(0,${-(h)})`);
      });



               
              };


  renderLegend();
  renderMap();

};